<template>
  <div class="table-teams">
    <div class="the-table">
      <div class="headers">
        <div class="row">
          <span>Distributor Name</span>
          <span>Members</span>
          <span>Open Cases</span>
          <span>Created</span>
          <span>Options</span>
        </div>
      </div>
      <div class="table">
        <div 
          class="row"
          v-for="(team, index) in teams"
          :key="index"
          >
          <span>
            {{ team.name }}
          </span>
          <span>
            {{ team.users_count }}
          </span>
          <span>
            {{ team.projects_count }}
          </span>
          <span>
            {{ formattedDate(team.created_at) }}
          </span>
          <span>
            <Link :href="`/admin/team/${team.id}/edit`">
              <i class="fal fa-pencil"/>
            </Link>
            <i 
              class="fal fa-trash-alt"
              v-if="$page.props.user.user_type == 'admin'"
              @click="deleteTeam(team.id)"
              />
          </span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link
  },
  props: {
    teams: Object,
  },
  methods: {
    deleteTeam(id){
      let message = 'Are you sure you wish to delete this team? You CANNOT undo this!'

      if(confirm(message)){
        this.$inertia.post(`/admin/team/${id}/delete`)
      }
    },
    formattedDate(theDate) {
      return moment(theDate).format('Do MMMM YYYY')
    }
  },
  mounted(){
    // console.log(this.teams) 
  }
}
</script>

<style lang="sass" scoped>

.table-teams
  width: 100%
  display: flex
  flex-direction: column
  margin-bottom: 30px


  .the-table
    .headers
      font-size: 18px
      font-weight: 700
      font-family: 'Roboto Condensed', sans-serif
      color: #252525
      line-height: 1.1
      margin-bottom: 10px

      .row
        padding: 0 20px

    .row
      display: grid
      grid-template-columns: 1fr 0.3fr 0.3fr 0.3fr 0.3fr
      span
        display: flex
        align-items: center

        &:last-child
          justify-content: flex-end

    @media (max-width: 900px)
      overflow-x: auto
      
      .row
        display: flex

        span
          min-width: 190px

    .table
      width: 100%
      background-color: #fff
      border-radius: 8px
      box-shadow: 0 1px 3px rgba(#000, 0.12)
      padding: 0 20px

      .row
        font-size: 16px
        font-weight: 400
        font-family: 'Roboto', sans-serif
        color: #252525
        line-height: 1.1
        height: 60px
        border-bottom: 1px solid #d0d0d0
        align-items: center

        &.deleting
          color: darken(#f00, 10%)

        &:last-child
          border-bottom: none

        .fal
          font-size: 22px
          color: #252525
          margin-left: 20px
          transition: all 300ms
          cursor: pointer

          &:hover
            opacity: 0.7


</style>
